<template>
    <hts-slide-over
        :show="props.show"
        color="main"
        :width-size="props.sizeSlideOver"
        :rules="form.rulesBranch"
        :submit="handleSubmitFormEditBranch"
        :custom="['header', 'footer']"
        :title="$t('labels.editBranch')"
        :undo-enable="true"
        @close="closeOverSide"
        @undo="undo()">
        <hts-card :title="$t('labels.generalInformation')">
            <div
                class="grid gap-4"
                :class="columnClass">
                <hts-form-input
                    v-model="dataFormEditBranch.name"
                    :label="$t('labels.branchName')"
                    :required="true"
                    :color="props.color"
                    name="name"
                    prop="name" />
                <hts-form-input
                    v-model="dataFormEditBranch.taxNumber"
                    :required="true"
                    :label="$t('labels.taxNumber')"
                    :color="props.color"
                    name="taxNumber"
                    prop="taxNumber" />
                <hts-form-input
                    v-model="dataFormEditBranch.website"
                    :label="$t('labels.website')"
                    :color="props.color"
                    :required="true"
                    name="website"
                    prop="website" />
                <hts-form-input
                    v-model="dataFormEditBranch.address"
                    :label="$t('labels.address')"
                    :color="props.color"
                    :required="true"
                    name="address"
                    prop="address" />
            </div>
        </hts-card>
    </hts-slide-over>
</template>

<script setup lang="ts">
import form from './imports/form'

const props = defineProps({
  show: {
    type: Boolean,
    default: false,
    required: true
  },
  color: {
    type: String,
    default: 'theme'
  },
  sizeSlideOver: {
    type: String,
    default: 'small'
  },
  sizeItemInput: {
    type: String,
    default: 'small'
  },
  column: {
    type: Number,
    default: 1
  },
  branchIsSelectedForEdit: {
    type: Object,
    default: () => {}
  }
})
const dataFormEditBranch = reactive({ ...form.initBranch })

const emits = defineEmits(['close', 'actionEditBranch', 'refreshTables'])

const closeOverSide = () => {
  emits('close')
}

watch(props, () => {
  _init()
})

const _init = () => {
  Object.assign(dataFormEditBranch, props.branchIsSelectedForEdit)
}
const undo = () => {
  _init()
}

const handleSubmitFormEditBranch = () => {
  const api = {
    url: '/company/branch/update',
    method: 'put'
  }
  const data = {
    name: dataFormEditBranch?.name,
    taxNumber: dataFormEditBranch?.taxNumber,
    address: dataFormEditBranch?.address,
    website: dataFormEditBranch.website
  }

  $api(api, { body: { ...data, id: props.branchIsSelectedForEdit._id } })
    .then((data) => {
      if (!data) {
        return true
      }
      const responseData: any = data.data.value
      if (!responseData) {
        return true
      }
      if (responseData.success) {
        Object.assign(dataFormEditBranch, { ...form.initBranch })
        emits('refreshTables')
        process.client && $toast().success($t('labels.editSuccess'))
        emits('close')
      }
    })
    .catch((error: any) => error)
}

const columnClass = computed(() => {
  if ($lodash.inRange(props.column, 1, 12)) {
    return `grid-cols-${props.column}`
  }

  return 'grid-cols-1'
})
</script>
